import { Formik } from "formik";
import { Button } from "primereact/button";
import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import * as yup from "yup";
import loginImage1 from "../../../assets/images/loginImage3.png";
import { Image } from "primereact/image";
import logo from "../../../assets/images/logo.svg";
import logo1 from "../../../assets/images/logoLoginScreen.svg";
import OtpInput from "react-otp-input";

import { InputNumber } from "primereact/inputnumber";

import "./VerifcationScreen.css";
import { resendOTP, validateOTP } from "../../../services/auth.service";
import useToast from "../../../context/toast.hook";
import { Toast } from "primereact/toast";

const VerificationScreen = () => {
  const { errorToast, successToast, toastRef } = useToast();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();

  const [OTP, setOTP] = useState("-----");

  const navigate = useNavigate();

  //Yup Form Schema Validitions
  const schema = yup.object().shape({
    email: yup.string().email("Must be valid Email"),
  });

  // Form Intial Values - If its New Form
  const initialValues = {
    email: "",
  };

  const handleSubmit = () => {
    setLoading(true);
    const email = searchParams.get("email");
    validateOTP({ otpCode: OTP, email })
      .then((res) => {
        successToast(res?.data?.message);
        navigate(res?.data?.redirectUrl);
        setLoading(false);
      })
      .catch((error) => {
        errorToast(error);
        setLoading(false);
      });
  };

  const handleResendOTP = () => {
    resendOTP({
      email: searchParams.get("email"),
    })
      .then((res) => {
        successToast(res?.data?.message);
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  return (
    <>
      <Toast ref={toastRef} />
      <div
        className="px-5 min-h-screen h-20rem flex justify-content-center align-items-center border"
        style={{ backgroundColor: "#1C9894" }}
      >
        <div
          className="border-1 surface-border surface-card  py-7 px-4 md:px-7 z-1 auth-container"
          style={{ boxShadow: "0px 72px 80px -48px #223A28" }}
        >
          <div className="mainLogoContainer">
            <div className="logoContainer1">
              <Image src={logo} alt="Opta" imageClassName="max-w-10rem" />
            </div>
            <div className="logoContainer2">
              <Image src={logo1} alt="Opta" imageClassName="max-w-10rem" />
            </div>
          </div>

          <div className="mb-4">
            <div className="innerLoginBox">
              Please enter your Verification code
            </div>
          </div>
          <Formik
            validationSchema={schema}
            onSubmit={handleSubmit}
            initialValues={initialValues}
            enableReinitialize
          >
            {({ handleSubmit, handleChange, values, touched, errors }) => (
              <form noValidate>
                <div className="flex flex-column" style={{ marginTop: "13%" }}>
                  <div className="field w-full">
                    <label htmlFor="email" className="block text-800">
                      <strong>Verification Code</strong>
                    </label>

                    <div className="OTPbox">
                      <OtpInput
                        value={OTP}
                        numInputs={5}
                        separator={<span style={{ color: "white" }}>--</span>}
                        onChange={(e) => {
                          setOTP(e);
                        }}
                        containerStyle={{ color: "inherit", marginTop: "10px" }}
                        inputStyle={{
                          width: "54px",
                          height: "54px",
                          background: "#FFFFFF",
                          borderRadius: "5px",
                          border: "1px solid",
                          borderColor: "#b8d6bf",
                          fontSize: "20px",
                          margin: "5px",
                        }}
                        renderInput={(props) => (
                          <input type="number" {...props} />
                        )}
                        inputClassName="otpInput"
                      />
                    </div>

                    <div onClick={handleResendOTP} className="resendCode">
                      Resend Code
                    </div>
                  </div>

                  <div className="loginButtonsVerificationForm">
                    <div onClick={handleSubmit} className="LoginButton">
                      <strong>Submit</strong>
                    </div>

                    <Link
                      to="/forgot"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <div className="CancelButton">
                        <strong>Cancel</strong>
                      </div>
                    </Link>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
        <div className="loginImage">
          <img className="img-wrap" src={loginImage1} alt="Opta" />
        </div>
      </div>
    </>
  );
};

export default VerificationScreen;
